import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconForum = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M3 5h12v8H7l-4 3z' />
      <path d='M9 16v1h8l4 3V9h-4' />
    </g>
  </SDIcon>
)

export default IconForum
